import { Link } from 'react-router-dom'
import { FaArrowRight } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { leadershipCta } from '../../data/leadershipPageData'

function LeadershipPageCta() {
  const { title, description, primaryCta, secondaryCta } = leadershipCta

  return (
    <AnimatedSection className="leadership-cta">
      <div className="container corp-container">
        <div className="leadership-cta__bar">
          <div className="leadership-cta__copy">
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
          <div className="leadership-cta__actions">
            <Link className="leadership-btn leadership-btn--gold" to={primaryCta.to}>
              {primaryCta.label}
              <FaArrowRight aria-hidden="true" />
            </Link>
            <Link className="leadership-btn leadership-btn--ghost" to={secondaryCta.to}>
              {secondaryCta.label}
              <FaArrowRight aria-hidden="true" />
            </Link>
          </div>
        </div>
      </div>
    </AnimatedSection>
  )
}

export default LeadershipPageCta
